import React, { useContext } from 'react';

import { mdiDotsHorizontal } from '@mdi/js';
import Icon from '@mdi/react';
import { Button, Menu, MenuItem, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useContainer } from 'unstated-next';
import { RosterContext } from '../../../../../context/RosterContext';
import { ActionsTableCell, StyledTableCell } from '../../../styles/table-styles';
import ClassContainer from '../../../../ClassModal/ClassContainer';

const StyledTableRow = styled(TableRow)`
    padding: 2rem;
`;

const MenuIcon = styled(Icon)`
    max-width: 35px;
    color: ${(props) => props.theme.colors.primary.main};
    height: 32px;
`;

const UnenrollMenuItem = styled(MenuItem)`
    color: ${(props) => props.theme.colors.error};
`;

export interface StudentTableRowProps {
    student: any;
}

const StudentTableRow: React.FC<StudentTableRowProps> = ({ student }) => {
    const { t } = useTranslation('roster');
    const { setOpenEditModal, setOpenDeleteModal, setSelectedStudentId, setOpenChangeHostModal } = useContext(RosterContext);
    const { hostEmail } = useContainer(ClassContainer);

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleEdit = (id) => {
        setSelectedStudentId(id);
        setOpenEditModal(true);

        handleClose();
    };

    const handleChangeHost = (id) => {
        setSelectedStudentId(id);
        setOpenChangeHostModal(true);

        handleClose();
    };

    const handleDelete = (id) => {
        setSelectedStudentId(id);
        setOpenDeleteModal(true);

        handleClose();
    };

    const isHost = student.email === hostEmail;
    const isTeacher = student.role === 'teacher';
    const canMakeHost = !isHost && student.email && student.has_zoom_login && isTeacher;

    const roleText = isHost ? t('roles.lead_instructor') : t(`roles.${student.role}`);

    return (
        <StyledTableRow>
            <StyledTableCell>{student.user_name}</StyledTableCell>
            <StyledTableCell>{student.email}</StyledTableCell>
            <StyledTableCell>{roleText}</StyledTableCell>
            <ActionsTableCell>
                <Button id="student-actions" size={'small'} onClick={handleClick}>
                    <MenuIcon path={mdiDotsHorizontal} />
                </Button>
            </ActionsTableCell>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'student-action-button' }}
            >
                {canMakeHost && <MenuItem onClick={() => handleChangeHost(student.student_id)}>{t('make-lead-instructor')}</MenuItem>}
                <MenuItem onClick={() => handleEdit(student.student_id)}>{t('Edit')}</MenuItem>
                <UnenrollMenuItem onClick={() => handleDelete(student.student_id)}>{t('Unenroll')}</UnenrollMenuItem>
            </Menu>
        </StyledTableRow>
    );
};

export default StudentTableRow;
